// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vMty","title":"styles_title__23Vu6"};